module.exports = __webpack_public_path__ + "static/images/technology_1_4.2b4e45f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology_1_4.png
// module id = 9b5/
// module chunks = 8